module.exports = __webpack_public_path__ + "img/coverimg3.401eb379.png";